import { Button } from "react-bootstrap"; // Assuming you are using Bootstrap
import * as XLSX from "xlsx";
import download_icon from "../../Icons/download_icon.png";
import React, { useState, useEffect } from "react";
import axios from "axios";

const super_admin = localStorage.getItem("super_admin");
const isSuperAdmin = super_admin === "true" || super_admin === true;
const ExcelExport = ({ supplierDetailResponse }) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [vendorCategory, setVendorCategory] = useState([])
  const [vendorSupplySource, setVendorSupplySource] = useState([])

  useEffect(() => {
    GetVendorCategory()
    getCurrentVendorCategory()
    GetVendorSupplySurce()

  }, []);

  function GetVendorCategory() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}AdminGet/GetVendorCategory`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {         
          setVendorCategory(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function getCurrentVendorCategory(categoryId) {
    if (categoryId !== null || categoryId !== undefined) {
      const category = vendorCategory.find((cat) =>
        cat.Tseed == categoryId);
      if (category !== undefined) {
        return category.Category_Name
      }
    }

  }

  function GetVendorSupplySurce() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}AdminGet/GETVendorSupplySourceDetails`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {          
          setVendorSupplySource(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function getCurrentVendorSupplySource(Id) {
    if (Id !== null || Id !== undefined) {
      const supplySource = vendorSupplySource.find((source) =>
        source.Tseed == Id);
      if (supplySource !== undefined) {
        return supplySource.State_Name
      }
    }

  }

  const exportToExcel = () => {

    // Check if leadResponse is not undefined or empty
    if (!supplierDetailResponse || supplierDetailResponse.length === 0) {
      return;
    }

    const headers = [
      "Vendor ID",
      "GUID",
      "FirstName",
      "LastName",
      "DisplayName",
      "CompanyName",
      "Email",
      "Category",
      "Work Phone1",
      "Work Phone2",
      "Supply Source",
      "Payables",
      "Unused Credits",
      "MailSent"
    ];


    const data = supplierDetailResponse.map((item, index) => ({
      "Vendor ID": item.Vendor_Id,
      "GUID": item.VendorGUID,
      "FirstName": item.VendorFirstName,
      "LastName": item.VendorLastName,
      "DisplayName": item.DisplayName,
      "CompanyName": item.CompanyName,
      "Email": item.VendorEmail,
      "Category": getCurrentVendorCategory(item.VendorCategory),
      "Work Phone1": item.Phone1,
      "Work Phone2": item.Phone2,
      "Supply Source": getCurrentVendorSupplySource(item.SupplySource),
      "Payables": item.Payables,
      "Unused Credits": item.Unused_Credits,
      "MailSent": item.MailSent === null ? "False" : "True"
    }));


    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers });

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

    // Generate today's date in YYYYMMDD format
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, "");

    // Save the Excel file with the new name
    const fileName = `VendorsList_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, fileName, { type: "array" });
  };

  return isSuperAdmin ? (
    <button
      onClick={exportToExcel}
      style={{
        height: "47px",
        border: "1px solid #C0C6CC",
        borderRadius: "7.5px",
        color: "#6A6A6A",
      }}
    >
      <img src={download_icon} alt="download" /> Download Excel
    </button>
  ) : null;
};

export default ExcelExport;
